<template>
  <div class="course__btnContanier">
    <div class="course__btnTop">
      <div class="course__flexCenter">
        <div class="course__price">￥<span class="course__bigPrice">{{this.coursePrice}}</span>.{{this.courseDotPrice}}</div>
        <div class="course__coupon" v-if="coupon">{{this.coupon}}</div>
      </div>
      <div
        class="course__tryListen"
        v-if="isOpenTryListen"
        v-fastclick="() => tryListen()"
        v-log:click.ev__course_detail_play="evLogTrack"
      >{{this.buttonName}}</div>
      <div
        class="course__buy"
        v-fastclick="() => router()"
        v-log:click="{page_name, title, name: title, product_name: title, h5_type, product_id, element_name: '点击购买按钮'}"
      >立即购买</div>
    </div>
    {{diffPrice()}}
    <div class="course__btnWhite"></div>
  </div>
</template>
<script>
import { JS2Native, env, httpRequest, href, webSDK } from '../utils';
export default {
  props: {
    price: {
      type: Number,
      default: 0
    },
    routerPath: {
      type: String,
      default: ''
    },
    buttonName: {
      type: String,
      default: '试听'
    },
    product_id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    page_name: {
      type: String,
      default: ''
    },
    h5_type: {
      type: String,
      default: ''
    },
    newClass: {
      type: String,
      default: ''
    },
    isOpenTryListen: {
      type: Boolean,
      default: true
    },
    coupon: {
      type: String,
      default: ''
    },
    evLogTrack: {
      type: Object
    },
    isRouter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      coursePrice: '',
      courseDotPrice: '00',
    };
  },
  mounted() {
    this.diffPrice();
  },
  methods: {
    tryListen() {
      this.$emit('tryListen');
    },
    router() {
      if (this.isRouter) {
        this.$emit('routerTo');
        return;
      }
      // 线上查到有些课程路由没有igc_from，导致订单追踪不到，所以这里默认加上
      const defaultIgcFrom = 'igcCourseVideo';
      let path = this.routerPath;

      // 判断当前页面路由没有igc_from，并且path中没有igc_from，给path加上默认的igc_from为igcCourseVideo
      if (this.$route.query.igc_from === undefined && path.indexOf('igc_from') === -1) {
        // 判断path有没有参数
        if (path.indexOf('?') === -1) {
          path = `${path}?igc_from=${defaultIgcFrom}`;
        } else {
          path = `${path}&igc_from=${defaultIgcFrom}`;
        }
      }
      href(path);
    },
    diffPrice() {
      if (this.price.toString().indexOf('.') > 0) {
        this.coursePrice = this.price.toString().split('.')[0];
        this.courseDotPrice = this.price.toString().split('.')[1];
      } else {
        this.coursePrice = this.price;
      }
    }
  }
};
</script>
<style lang="scss">
body {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}

  .course {
    &__flexCenter {
      flex: 1;
      display: flex;
      align-items: baseline;
    }

    &__coupon {
      font-size: .12rem;
      color: #A1A1B3;
    }

    &__tryListen {
      border: 1px solid #E6E6EB;
      border-radius: .24rem;
      color: #6D6D80;
      font-size: .16rem;
      width: .8rem;
      height: .4rem;
      text-align: center;
      line-height: .4rem;
      margin-right: .1rem;
    }

    &__bigPrice {
      color: #FF5F2E;
      font-size: .24rem;
    }

    &__buy {
      width: 1.2rem;
      height: .4rem;
      line-height: .4rem;
      text-align: center;
      background: #FF5F2E;
      color: #fff;
      font-size: .16rem;
      border-radius: .24rem;
      font-weight: bold;
    }

    &__price {
      color: #FF5F2E;
      font-size: .18rem;
      font-family: Oswald-Medium;
      margin-right: .06rem;
    }

    &__btnTop {
      height: .56rem;
      display: flex;
      align-items: center;
    }

    &__btnContanier {
      background: #fff;
      padding-left: .2rem;
      padding-right: .2rem;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 3;
      height: calc(0.56rem + env(safe-area-inset-bottom));
    }
  }
</style>
